import React from 'react';
import styled from 'styled-components';
import { HEADERS } from '../constants/CompareTags.constants';
import i18n from 'i18next';

const ModalHeaderLabel = styled.div`
  font-size: 18px;
  line-height: 22px;
  color: #3c3d3a;
  text-align: center;
`;

const SelectAssetsModalHeader = ({ machineName, isEditMode }) => (
  <ModalHeaderLabel>
    {machineName && (
      <>
        {i18n.t(HEADERS.MACHINE_SELECTED, { defaultValue: 'Please select the assets that you wish to compare with ' })}
        <b>{machineName}</b>
      </>
    )}
    {!machineName && !isEditMode && i18n.t(HEADERS.MACHINE_NOT_SELECTED, { defaultValue: 'Please select the assets that you wish to compare tags from' })}
    {isEditMode && (
      <>
        {i18n.t(HEADERS.EDIT_MODE, { defaultValue: 'Please add more assets to the config if required or ' })}
        <b>{i18n.t('common.continueUppercase', { defaultValue: 'CONTINUE' })}</b>
      </>
    )}
  </ModalHeaderLabel>
);

export default SelectAssetsModalHeader;
